// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import IssuesCloseOutlinedSvg from "@ant-design/icons-svg/es/asn/IssuesCloseOutlined";
import AntdIcon from '../components/AntdIcon';

var IssuesCloseOutlined = function IssuesCloseOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: IssuesCloseOutlinedSvg
  }));
};

IssuesCloseOutlined.displayName = 'IssuesCloseOutlined';
export default React.forwardRef(IssuesCloseOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/IssuesCloseOutlined.js
// module id = 1381
// module chunks = 0